import { ExchangeOrderSide, ExchangeOrderType } from "TradeAPILib/dist/src/ExchangeAPIAdapter/TradeTypeDef";
import { Mixpanel as MixpanelOrigin } from "./def";
import DataReporter from "landings/Analytics/DataReporter";

declare global {
    interface Window {
        mixpanel?: MixpanelOrigin;
        wrappedMixpanel: Mixpanel;
    }
}

/**
 * @deprecated 老的mixpanel统计调用方式，使用 {@link DataReporter}同时上报多个平台
 * 事件定义：https://docs.google.com/spreadsheets/d/1wWoSH2bYsPXhxTaUiJ-VcGhVnGGIMyv0gPXAudDj_mc/edit#gid=0
 */
export default class Mixpanel {
    public static trackEvent: MixpanelOrigin["track"] = (eventName, ...props) => {
        DataReporter.report(eventName, props);
    };

    /**
     * 上报数据的作用域
     */
    static report = {
        visitReferralLink(code: string) {
            Mixpanel.trackEvent("visit_referral_link", { share_code: code });
        },

        getBot() {
            Mixpanel.trackEvent("get_bot_success", {});
        },

        signUpSource(source: string) {
            Mixpanel.trackEvent("visit_signup_page", { position: source });
        },

        visitBlog() {
            Mixpanel.trackEvent("onboard_visit_blog", {});
        },

        visitDeposit(source: string) {
            Mixpanel.trackEvent("visit_deposit", { position: source });
        },

        visitTrade(source: string) {
            Mixpanel.trackEvent("visit_trade", { position: source });
        },

        visitMarket(source: string) {
            Mixpanel.trackEvent("visit_market", { position: source });
        },

        joinCommunity(type: string) {
            Mixpanel.trackEvent("join_community", { community_type: type });
        },

        manualTrade(order_type: ExchangeOrderType, side: ExchangeOrderSide, base: string, quote: string) {
            Mixpanel.trackEvent("manual_trade", { order_type, side, base, quote });
        },

        qrScanSuccess(scan_times: number, scan_failed_times: number) {
            Mixpanel.trackEvent("web_login_with_qrscan", { from_web: "1", scan_times, scan_failed_times });
        },

        learnCallEntry(from_web: string) {
            Mixpanel.trackEvent("learning_call_entry", { from_web });
        },
        depositCryptoGuide(from_web: string) {
            Mixpanel.trackEvent("crypto_deposit_guide", { from_web });
        },

        moonCreate(from_web: string, invest: number, symbol: string) {
            Mixpanel.trackEvent("trading_bot_moon", { from_web, invest, symbol });
        },

        botCreateEvent(base: string, quote: string, bot_type: ExchangeOrderType, isAI: boolean) {
            Mixpanel.trackEvent("create_trading_bot", { bot_type, ai: isAI ? 1 : 0, base, quote });
        },

        inviteAttempt(sharing_position: string, sharing_type: "copy" | "share" | "download") {
            Mixpanel.trackEvent("invite_attempt", { sharing_position, sharing_type });
        },

        submitKYC() {
            Mixpanel.trackEvent("submit_kyc", {});
        },

        userInviteInfo(referral_signup_count: number, referral_pro_count: number) {
            Mixpanel.trackEvent("user_invite_info", {
                referral_signup_count,
                referral_pro_count,
            });
        },

        userAuthorization(id: string) {
            Mixpanel.trackEvent("pionex_auth_other_login", { id: id });
        },
        kyc_US_StateNotSupport(data: { userId: string; email: string; state: string }) {
            Mixpanel.trackEvent("kyc_us_state_not_support", data);
        },

        visitWeb() {
            Mixpanel.trackEvent("usweb_visit_web", {});
        },
        /**
         * 判别用户是从什么地方进入的 一级 KYC
         * @param source
         */
        enterKycLevel1(source: string) {
            Mixpanel.trackEvent("enter_kyc_level1", { from_web: source });
        },
        kycLv1SmsCodeSendTimes(times: number) {
            Mixpanel.trackEvent("kyc_lv1_sms_send_count", { times });
        },
        /**
         *
         * @param type 1: sms; 2: voice
         */
        kycLv1SmsCodeSend(type: 1 | 2) {
            Mixpanel.trackEvent("kyc_lv1_sms_send", { from_web: type });
        },
        kycLv1SubmitTime(seconds: number) {
            Mixpanel.trackEvent("kyc_lv1_submit_time", { from_web: seconds });
        },
        kycLv1StayTime(seconds: number) {
            Mixpanel.trackEvent("kyc_lv1_stay_time", { from_web: seconds });
        },
        kycLv1CountrySelected() {
            Mixpanel.trackEvent("kyc_lv1_select_country", { from_web: 1 });
        },
        enterKycLevel2(source: string) {
            Mixpanel.trackEvent("enter_kyc_level2", { from_web: source });
        },
        kycLv2Submitted() {
            Mixpanel.trackEvent("kyc_level2_submit", { from_web: 1 });
        },
        kycInfoStatus(level_web: number) {
            Mixpanel.trackEvent("kyc_info_status", { level_web });
        },
        kycUSLv2Submitted() {
            Mixpanel.trackEvent("kyc_us_level2_submit", { from_web: 1 });
        },
        kycUSLv2ReSubmitted() {
            Mixpanel.trackEvent("kyc_us_level2_resubmit", { from_web: 1 });
        },
        kycUSLv2SubmittedGuide(to: "academy" | "telegram" | "discord" | "free_learn") {
            Mixpanel.trackEvent("kyc_us_level2_submit_guide", { from_web: to });
        },
        kycUSLv2Completed() {
            Mixpanel.trackEvent("kyc_us_level2_completed", { from_web: 1 });
        },
        kycUSLv2CompletedGuide(to: "academy" | "telegram" | "deposit" | "deposit-usd") {
            Mixpanel.trackEvent("kyc_us_level2_completed_guide", { from_web: to });
        },
        visitUSWireDeposit() {
            Mixpanel.trackEvent("visit_uswire_deposit", {});
        },
        visitUSWireTutorial() {
            Mixpanel.trackEvent("visit_uswire_tutorial", {});
        },
        visitUSWireAddTutorial() {
            Mixpanel.trackEvent("visit_uswire_addtutorial", {});
        },
        clickUSWireComplete() {
            Mixpanel.trackEvent("click_uswire_complete", {});
        },
        visitUSCardDeposit() {
            Mixpanel.trackEvent("visit_uscard_deposit", {});
        },
        clickUSCardAddCard() {
            Mixpanel.trackEvent("click_uscard_addcard", {});
        },
        clickUSCardSubmitCard() {
            Mixpanel.trackEvent("click_uscard_submitcard", {});
        },
        clickUSCardSubmitOrder() {
            Mixpanel.trackEvent("click_uscard_submitorder", {});
        },
        usWireClickDeposit() {
            Mixpanel.trackEvent("uswire_click_deposit", {});
        },
        usCardClickDeposit() {
            Mixpanel.trackEvent("uscard_click_deposit", {});
        },
        reportError(eventName: string, userId?: string, details?: string) {
            Mixpanel.trackEvent(eventName, {
                userId,
                details,
            });
        },
    };
}

window.wrappedMixpanel = Mixpanel;
